<nav class="slideInLeft">
  <ul class="list-sidebar bg-defoult" *ngFor="let menu of authenticatedMenus; let i = index;">
    <li *ngIf="menu.title === 'Home'">
      <a class="collapsed active" routerLink="" (click)="closeMenu()">
        <span>{{'global.menu.home' | translate}}</span>
      </a>
    </li>
    <li *ngIf="menu.title === 'Balance'">
      <a class="collapsed active" routerLink="balance" (click)="closeMenu()">
        <span>{{'global.menu.balance' | translate}}</span>
      </a>
    </li>
    <li *ngIf="menu.title === 'Transaction'">
      <a data-toggle="collapse" data-target="#Transaction" class="collapsed active">
        <span class="nav-label"> {{'global.menu.transaction' | translate }}
        </span>
      </a>
      <span class="bi bi-chevron-down"></span>
      <ul class="sub-menu collapse" id="Transaction">
        <div *ngFor="let subMenu of menu.subMenus">
          <li class="active sub-menu" *ngIf="subMenu.title === 'Fund Performance' ">
            <a [routerLink]="subMenu.link" routerLinkActive="active" (click)="closeMenu()"> <span> {{ 'global.menu.fund'
                | translate }} </span> </a>
          </li>
          <li class="active sub-menu" *ngIf="subMenu.title === 'Unit Price' ">
            <a [routerLink]="subMenu.link" routerLinkActive="active" (click)="closeMenu()"> <span> {{ 'global.menu.unit'
                | translate }} </span> </a>
          </li>
        </div>
      </ul>
    </li>
    <li *ngIf="menu.title === 'Information'">
      <a data-toggle="collapse" data-target="#Information" class="collapsed active">
        <span class="nav-label"> {{
          'global.menu.information' | translate }} </span></a>
      <span class="bi bi-chevron-down"></span>
      <ul class="sub-menu collapse" id="Information">
        <div *ngFor="let subMenu of menu.subMenus">
          <li class="active sub-menu" *ngIf="subMenu.title === 'FAQ' ">
            <a [routerLink]="subMenu.link" routerLinkActive="active" (click)="closeMenu()"> <span> Faq </span> </a>
          </li>
          <li class="active sub-menu" *ngIf="subMenu.title === 'Document Download' ">
            <a [routerLink]="subMenu.link" routerLinkActive="active" (click)="closeMenu()"> <span> {{
                'global.menu.document' | translate }} </span> </a>
          </li>
        </div>
      </ul>
    </li>
    <li *ngIf="menu.title === 'Contact'">
      <a class="collapsed active" routerLink="contact" (click)="closeMenu()">
        <span>{{'global.menu.contact' | translate}}</span>
      </a>
    </li>
    <li *ngIf="menu.title === 'Administration'">
      <a data-toggle="collapse" data-target="#Administration" class="collapsed active">
        <span class="nav-label"> {{'global.menu.admin.main'|translate}} </span></a>
      <span class="bi bi-chevron-down"></span>
      <ul class="sub-menu collapse" id="Administration">
        <div *ngFor="let subMenu of menu.subMenus">
          <li class="active sub-menu" *ngIf="subMenu.title === 'Add Fund' ">
            <a [routerLink]="subMenu.link" routerLinkActive="active" (click)="closeMenu()"> <span>
                {{'global.menu.addfund'|translate}} </span></a>
          </li>
          <!-- <li class="active sub-menu" *ngIf="subMenu.title === 'Upload Fund Performance' ">
            <a routerLink="fundperformance-upload" routerLinkActive="active" (click)="closeMenu()"> <span>
              Upload Fund Performance</span></a>
          </li> -->
          <li class="active sub-menu" *ngIf="subMenu.title === 'Balance' ">
            <a [routerLink]="subMenu.link" routerLinkActive="active" (click)="closeMenu()"> <span>
                {{ 'global.menu.balance' | translate }} </span></a>
          </li>
          <li class="active sub-menu" *ngIf="subMenu.title === 'Resend Welcome Email' ">
            <a [routerLink]="subMenu.link" routerLinkActive="active" (click)="closeMenu()"> <span>
                {{'global.menu.resendmail'|translate}} </span></a>
          </li>
          <li class="active sub-menu" *ngIf="subMenu.title === 'Send Forgot Password' ">
            <a [routerLink]="subMenu.link" routerLinkActive="active" (click)="closeMenu()">
              <span>{{'global.menu.sendforgot'|translate}} </span></a>
          </li>
          <li class="active sub-menu" *ngIf="subMenu.title === 'Unlock User' ">
            <a [routerLink]="subMenu.link" routerLinkActive="active" (click)="closeMenu()"> <span> Unlock User
              </span></a>
          </li>
        </div>
      </ul>
    </li>
    <li *ngIf="menu.title === 'Account'">
      <a routerLink="password" routerLinkActive="active" class="collapsed active" (click)="closeMenu()">
        <span> {{'global.form.changepassword' | translate}} </span></a>
    </li>

    <li *ngIf="menu.title === 'Support'">
      <a routerLink="support/appconfig" routerLinkActive="active" class="collapsed active" (click)="closeMenu()">
        <span> {{'global.menu.support.appconfig' | translate}} </span>
      </a>
    </li>

    <li *ngIf="menu.title === 'Calculator'">
      <a data-toggle="collapse" data-target="#Calculator" class="collapsed active">
        <span class="nav-label"> Calculator </span></a>
      <span class="bi bi-chevron-down"></span>
      <ul class="sub-menu collapse" id="Calculator">
        <div *ngFor="let subMenu of menu.subMenus">
          <li class="active sub-menu" *ngIf="subMenu.title === 'Pension Calculator' ">
            <a [routerLink]="'calculator/pensioncalculator'" routerLinkActive="active" (click)="closeMenu()"> <span> {{
                'global.menu.calculatorm' | translate }} </span> </a>
          </li>
          <li class="active sub-menu" *ngIf="subMenu.title === 'Pension Calculator Setup' ">
            <a [routerLink]="'calculator/pensioncalculatorsetup'" routerLinkActive="active" (click)="closeMenu()">
              <span> {{ 'global.menu.calculators' | translate }} </span> </a>
          </li>
        </div>
      </ul>
    </li>

    <li *ngIf="menu.title === 'Risk Profile'">
      <a class="collapsed active" routerLink="riskprofile" (click)="closeMenu()">
        <span>{{'global.menu.riskProfile' | translate}}</span>
      </a>
    </li>
  </ul>
  <button class="btn btn-clear btn-block" (click)="logout()"> Sign out </button>
</nav>